<template>
  <div class="md-layout md-alignment-top-center">
    <div class="md-layout-item  md-medium-size-100" v-if="this.challenge">

      <!-- <md-card v-if="urlPaymentResult === 'success'">
        <md-card-header class="md-card-header-text md-card-header-green">
          <div class="card-text">
            <h4 class="title">Anmeldung erfolgreich!</h4>
          </div>
        </md-card-header>
        <md-card-content>
          <div class="md-display-1" style="text-align: center">
            <md-icon class="md-size-5x success">sentiment_satisfied_alt</md-icon> <br>
            Vielen Dank, dass du dich der Challenge angeschlossen hast!
          </div>
        </md-card-content>
      </md-card> -->

      <landing-page :landingPage="pageInfo" v-if="pageInfo" />

      <small-challenge-info-card v-if="pageInfo" :challenge="challenge" :displayBackButton="false"/>

      <challenge-details-card v-else card-header="true">
        <img slot="imageHeader" :src="challenge.titleImage" v-if="challenge.titleImage" />
        <h1 slot="title" v-html="challenge.title" />
        <h3 slot="date">
              {{
                this.formatFromToDate(this.challenge.start, this.challenge.end)
              }}
        </h3>
        <p slot="description" v-html="challenge.description" />
      </challenge-details-card>

      <!-- <md-card class="md-layout-item md-size-100" v-if="pageInfo">
        <md-card-header>
          <h1 v-if="pageInfo.title">{{pageInfo.title}}</h1>
          <h2 v-if="pageInfo.title">{{pageInfo.subtitle}}</h2>
        </md-card-header>
        <md-card-content>
          <div v-if="pageInfo.images && pageInfo.images.length">
            <div v-if="pageInfo.images.length == 1">
              <img :src="pageInfo.images[0]">
            </div>
            <div v-else>
              <vueper-slides
                  class="no-shadow"
                  :slideMultiple="false"
                  :arrowsOutside="true"
                  :bulletsOutside="false"
                  :visibleSlides="1"
                  :gap="4"
                  :fixedHeight="'500px'"
                  :dragging-distance="50"
              >
                <template #arrow-left>
                  <i class='far fa-chevron-left' />
                </template>

                <template #arrow-right>
                  <i class='far fa-chevron-right'/>
                </template>
                <vueper-slide v-for="(image, index) in pageInfo.images" :key="index">
                  <template v-slot:content>
                    <div ref="sliderItems">
                      <md-card class="md-card-plain">
                        <md-card-media class="md-ratio-4-3">
                          <img :src="image">
                        </md-card-media>
                      </md-card>
                    </div>
                  </template>
                </vueper-slide>
              </vueper-slides>
            </div>
          </div>
          <div v-if="pageInfo.description" v-html="pageInfo.description">
          </div>
        </md-card-content>
      </md-card> -->

      <cart
        v-if="
            challenge &&
            challenge.merchandise &&
            challenge.merchandise.length
        "
        :challenge="challenge"
        :initialVoucherCode="urlCode"
      />
      <md-card v-else>
        <md-card-header class="md-card-header-green">
          <h3 class="title">
            Challenge Anmeldung
          </h3>
        </md-card-header>
        <md-card-content>
          <template v-if="challenge.finished">
            <div><h2>Die Anmeldung ist bereits geschlossen</h2></div>
          </template>
          <template v-if="!challenge.finished">
            <div>
            <md-button
              class="md-round md-warning md-sm"
              @click="redirect('/Login')"
            >
              Anmelden
            </md-button>
            Bitte log dich vorher ein, damit du dich zu der Challenge anmelden kannst.
            </div>
            <div>
              <md-button
                class="md-round md-info md-sm"
                @click="redirect('/Register')"
              >
                Registriere dich jetzt
              </md-button>
              Falls du noch keinen Benutzer hast, bitte registriere dich.
            </div>
          </template>
        </md-card-content>
      </md-card>

      <!-- Anmeldung geht anonym nicht! -->
      <!-- <md-card
        v-else-if="
            challenge &&
            challenge.joinForm &&
            challenge.joinForm.fields &&
            challenge.joinForm.fields.length
        "
      >
        <md-card-header class="md-card-header-text md-card-header-green">
          <div class="card-text">
            <h4 class="title">Jetzt mitmachen!</h4>
          </div>
        </md-card-header>
        <md-card-content>
          <dynamic-form
            :formFields="challenge.joinForm.fields"
            @submit="submit($event)"
            submitButtonText="Jetzt anmelden!"
            style="max-width: 600px; margin: 0 auto;"
          />
        </md-card-content>
      </md-card> -->

    </div>
    <md-progress-spinner v-else md-mode="indeterminate"></md-progress-spinner>
  </div>

</template>

<script>
import { ChallengeDetailsCard } from "@/components";
import datetime from "@/utils/datetime";
import Cart from "@/components/Cart/Cart";
import debounce from "@/utils/debounce";
import SmallChallengeInfoCard from 'sports4me-web_components/atomic-design/molecules/small-challenge-info-card.vue';
import LandingPage from 'sports4me-web_components/atomic-design/molecules/landing-page.vue';

export default {
  components: {
    ChallengeDetailsCard,
    Cart,
    SmallChallengeInfoCard,
    LandingPage
  },
  data() {
    return {
      urlCode: this.$route.query['code'] || this.$route.query['voucher'] || undefined,
      urlPaymentResult: this.$route.query["payment-result"] || undefined, // value: 'success' or 'cancel'
      defaultImage: "/img/bg3.jpg",
      id: this.$route.params.id,
      challenge: null,
      pageInfo: undefined,
      height: "0px",
      stretch: false,
      doResize: debounce(() => {
        this.stretch = false;
        this.$nextTick(() => {
          if (this.$refs.sliderItems) {
            this.height =
              Math.max(
                ...this.$refs.sliderItems.map(
                  (el) => el.getBoundingClientRect().height
                )
              ) + "px";
          }
          this.stretch = true;
        });
      }, 600),
    };
  },
  destroyed() {
    window.removeEventListener("resize", this.doResize);
  },
  created() {
    window.addEventListener("resize", this.doResize);
  },
  mounted() {
    this.doResize();

    if (this.urlPaymentResult === "success") {
      this.$notify({
        timeout: 0,
        message:
          "Danke für deine Bestellung, du erhältst eine Bestätigung per Mail.",
        icon: "add_alert",
        horizontalAlign: "right",
        verticalAlign: "top",
        type: "success"
      });
      window.scrollTo(0, 0);
    }
    if(this.urlCode) {
      this.$store.dispatch("queryAPI", {
        url: `/rest/challenge/checkCode/${this.id}/${this.urlCode}`
      })
      .then(res => {
        this.pageInfo = res.pageInfo || undefined;
        setTimeout(() => {
          this.doResize();
        });
      })
    }
    this.$store
      .dispatch("queryAPI", {url: "/rest/challenge/public/" + this.id})
      .then(data => (this.challenge = data));
  },
  methods: {
    ...datetime,
    redirect(path) {
      this.$router.push({ path, query: { redirect: "/Challenges/" + this.challenge._id } });
    }
  }
};
</script>
<style scoped>
div.md-layout.md-alignment-top-center {
  padding-top: 30px;
}
</style>
